import { UnknownError } from "@iglu/common/error";
import ReactError from "./ReactError.js";
import UncaughtError from "./UncaughtError.js";

window.UnknownError = UnknownError;
window.ReactError = ReactError;
window.UncaughtError = UncaughtError;
